module.exports = __webpack_public_path__ + "353b91c76ebbf42972f27d4a3b6c0ecc.pdf";